import apiClient from './apiClient'
import ApiV1 from './v1/index'
import ApiV2 from './v2/index'
import ApiUhub from './uhub/index'
import bannersApi from './v1/banners'
import bannersTypesApi from './v1/bannersTypes'
import citiesApi from './v1/cities'
import propertiesApi from './v1/properties'
import personsApi from './v1/persons'
import landingPagesApi from './v1/landingPages'
import enterprisesApi from './v1/enterprises'
import authApi from './v1/auth'
import realEstatesApi from './v1/realEstates'
import placeTypes from './v1/placeTypes'
import places from './v1/places'
import resourcesApi from './v1/resources'
import redirectsApi from './v1/redirects'
import pagesApi from './v1/pages'
import reportsApi from './v1/reports'
import addonsApi from './addons'
import amenitiesApi from './v1/amenities'
import condominiumsApi from './condominiums'
import colorsSchemaApi from './v1/colorsSchema'
import customCssApi from './v1/customCss'
import themeConfigApi from './v1/themeConfig'
import notifications from './notifications'
import usersApi from './users'
import rolesApi from './roles'
import permissionsApi from './permissions'
import reviewsApi from './reviews'
import googleBusinessApi from './googleBusiness'

export default function api() {
  const api = apiClient({ prefix: 'api' })
  const data = { apiClient: api }

  return {
    v1: ApiV1(),
    v2: ApiV2(),
    uhub: ApiUhub(),
    service: api,
    banners: bannersApi(data),
    bannersTypes: bannersTypesApi(data),
    cities: citiesApi(data),
    places: places(data),
    placeTypes: placeTypes(data),
    properties: propertiesApi(data),
    persons: personsApi(data),
    landingPages: landingPagesApi(data),
    enterprises: enterprisesApi(data),
    auth: authApi(data),
    realEstates: realEstatesApi(data),
    resources: resourcesApi(data),
    redirects: redirectsApi(data),
    pages: pagesApi(data),
    reports: reportsApi(data),
    addons: addonsApi(data),
    amenities: amenitiesApi(data),
    condominiums: condominiumsApi(data),
    colorsSchema: colorsSchemaApi(data),
    customCss: customCssApi(data),
    themeConfig: themeConfigApi(data),
    notifications: notifications(data),
    users: usersApi(data),
    roles: rolesApi(data),
    permissions: permissionsApi(data),
    reviews: reviewsApi(data),
    googleBusiness: googleBusinessApi(data),
  }
}
